import { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import ErrorPage from '../ErrorPage/ErrorPage';

function SECTable({ rows, columns, pageSize = 10, density = "compact", loading = false, error = null, onRowClick, changeField }) {
    const [row, setRow] = useState(null)

    function saveInputName(params, event){
        setRow(params.row)
    }

    function processCellEdit(params, event){
        changeField(params, row)
    }

    return (
      <div data-tour="batches-step-1" style={{ width: "100%", height: "100%" }}>
        {error === null && (
          <DataGrid
            sx={{ backgroundColor: "white" }}
            rows={rows}
            columns={columns}
            pageSize={pageSize}
            density={density}
            onRowClick={onRowClick}
            loading={loading}
            rowsPerPageOptions={[10]}
            onCellEditStart={saveInputName}
            onCellEditCommit={processCellEdit}
          />
        )}

        {error !== null && (
          <ErrorPage
            status={error.status > 0 ? error.status : 500}
            message={error.message}
          />
        )}
      </div>
    );
}

export default SECTable;